import './eventLog.scss';
import styling from '../core/styling';
import { create, createDiv } from '../core/domMan';
import { modeSpecificCssVariable } from '../core/themeColorsPicker';

export const identifier = 'eventlog';
export const wrapperName = `${identifier}Wrapper`;
const fadeIn = styling.getAnimationCss(styling.animations.fadeIn);

export const createEventLog = (parentElement, data, displayedMode) => {
    while (parentElement.lastElementChild) {
        parentElement.removeChild(parentElement.lastElementChild);
    }

    const wrapper = createDiv(parentElement, { id: wrapperName, className: `items-center container hideOnSmall` });

    const logsPlaceholder = createDiv(wrapper, { className: `w-full h-full ` });

    const logContainer = createDiv(logsPlaceholder, { id: identifier, className: 'flex flex-row gap-4 w-full justify-around' });
    const innerLogContainer = createDiv(logContainer, { id: identifier, className: 'flex flex-row gap-4 overflow-hidden text-xxs font-mono font-bold' });

    const hitsColumn = createDiv(innerLogContainer, { className: 'flex flex-col gap-1' });
    const urlColumn = createDiv(innerLogContainer, { className: 'flex flex-col grow-1 gap-1 overflow-hidden' });
    const codeColumn = createDiv(innerLogContainer, { className: 'flex flex-col gap-1' });
    const infoColumn = createDiv(innerLogContainer, { className: 'flex flex-col gap-1 ' });

    data = data.slice(0, 5);

    data.forEach(log => {
        const color = modeSpecificCssVariable(displayedMode, `--color-${log.cssColor}`)

        const hits = createDiv(hitsColumn);
        hits.innerText = log.hits
        hits.style.color = color

        const url = createDiv(urlColumn, { className: 'd-inline-block overflow-hidden text-ellipsis text-nowrap ' });
        url.innerText = log.url
        url.style.color = color

        const code = createDiv(codeColumn);
        code.innerText = log.code
        code.style.color = color

        const info = createDiv(infoColumn, { className: 'text-xxs-height' });
        info.innerText = log.info
        info.style.color = color
    });

    styling.hide(logContainer);

    if (!data.length) {
        return logContainer;
    }

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    delay(100)
        .then(() => {
            return delay(500);
        })
        .then(() => {
            logContainer.classList.add(fadeIn);
            styling.show([logContainer]);

        });

    return logContainer;
}